import { abstractFilter } from './../abstractFilter'
import U from './../../lib-utils'
function F() {
  return (F.is(this) ? this.init : F.F).apply(
    this,
    Array.prototype.slice.call(arguments),
  )
}

var P = F.leu_extend(abstractFilter).prototype

P.apply_filter = function (current_value, params, field_name) {
  if (U.is_array(current_value)) {
    if (current_value.length > 0) {
      return current_value
    } else {
      return this.create_invalid_value(field_name, 'is empty')
    }
  } else {
    return this.create_invalid_value(field_name, 'is not an array')
  }
}

export default F
